/* eslint @typescript-eslint/no-unused-vars:0 */
import * as wasi from "./wasi_defs.js";
export class Fd {
    fd_allocate(offset, len) {
        return wasi.ERRNO_NOTSUP;
    }
    fd_close() {
        return 0;
    }
    fd_fdstat_get() {
        return { ret: wasi.ERRNO_NOTSUP, fdstat: null };
    }
    fd_fdstat_set_flags(flags) {
        return wasi.ERRNO_NOTSUP;
    }
    fd_fdstat_set_rights(fs_rights_base, fs_rights_inheriting) {
        return wasi.ERRNO_NOTSUP;
    }
    fd_filestat_get() {
        return { ret: wasi.ERRNO_NOTSUP, filestat: null };
    }
    fd_filestat_set_size(size) {
        return wasi.ERRNO_NOTSUP;
    }
    fd_filestat_set_times(atim, mtim, fst_flags) {
        return wasi.ERRNO_NOTSUP;
    }
    fd_pread(size, offset) {
        return { ret: wasi.ERRNO_NOTSUP, data: new Uint8Array() };
    }
    fd_prestat_get() {
        return { ret: wasi.ERRNO_NOTSUP, prestat: null };
    }
    fd_pwrite(data, offset) {
        return { ret: wasi.ERRNO_NOTSUP, nwritten: 0 };
    }
    fd_read(size) {
        return { ret: wasi.ERRNO_NOTSUP, data: new Uint8Array() };
    }
    fd_readdir_single(cookie) {
        return { ret: wasi.ERRNO_NOTSUP, dirent: null };
    }
    fd_seek(offset, whence) {
        return { ret: wasi.ERRNO_NOTSUP, offset: 0n };
    }
    fd_sync() {
        return 0;
    }
    fd_tell() {
        return { ret: wasi.ERRNO_NOTSUP, offset: 0n };
    }
    fd_write(data) {
        return { ret: wasi.ERRNO_NOTSUP, nwritten: 0 };
    }
    path_create_directory(path) {
        return wasi.ERRNO_NOTSUP;
    }
    path_filestat_get(flags, path) {
        return { ret: wasi.ERRNO_NOTSUP, filestat: null };
    }
    path_filestat_set_times(flags, path, atim, mtim, fst_flags) {
        return wasi.ERRNO_NOTSUP;
    }
    path_link(path, inode, allow_dir) {
        return wasi.ERRNO_NOTSUP;
    }
    path_unlink(path) {
        return { ret: wasi.ERRNO_NOTSUP, inode_obj: null };
    }
    path_lookup(path, dirflags) {
        return { ret: wasi.ERRNO_NOTSUP, inode_obj: null };
    }
    path_open(dirflags, path, oflags, fs_rights_base, fs_rights_inheriting, fd_flags) {
        return { ret: wasi.ERRNO_NOTDIR, fd_obj: null };
    }
    path_readlink(path) {
        return { ret: wasi.ERRNO_NOTSUP, data: null };
    }
    path_remove_directory(path) {
        return wasi.ERRNO_NOTSUP;
    }
    path_rename(old_path, new_fd, new_path) {
        return wasi.ERRNO_NOTSUP;
    }
    path_unlink_file(path) {
        return wasi.ERRNO_NOTSUP;
    }
}
export class Inode {
}
//# sourceMappingURL=fd.js.map